import { type FC } from "react";
import { useTranslation } from "react-i18next";
import type { Tags } from "../../../merge-tag/types";
import type { SerialisedLexicalEditorDesign } from "../../../message/editor/types/serialised-editor-design";
import type { ToTarget } from "../../../to/use-to-target";
import type { FollowUpChannelWithData, FollowUpSchemaType } from "../../reducer/schema";
import { isChatChannelWithData, isEmailChannelWithData } from "../../utils";
import { FollowUpBodySection } from "../follow-up-body/follow-up-body-section";
import { FollowUpMessageChat } from "./follow-up-message-chat";
import { FollowUpMessageEmail } from "./follow-up-message-email";

interface FollowUpMessageProps {
  channel: FollowUpChannelWithData;
  mergeTags: Tags;
  toTarget: ToTarget;
  setDesign: (val: SerialisedLexicalEditorDesign) => void;
  setChannelData: (data: FollowUpChannelWithData) => void;
  design: FollowUpSchemaType["design"];
}

export const FollowUpMessage: FC<FollowUpMessageProps> = ({
  channel,
  setChannelData,
  mergeTags,
  toTarget,
  setDesign,
  design,
}) => {
  const { t } = useTranslation();

  return (
    <FollowUpBodySection
      title={t("Message")}
      subtitle={t(
        "Modify our template or craft a custom message using our editor. Don't forget to use merge tags to make your Follow-Up personal.",
      )}
    >
      {isChatChannelWithData(channel) && (
        <FollowUpMessageChat
          channel={channel}
          setChannelData={setChannelData}
          mergeTags={mergeTags}
          onChange={setDesign}
          toTarget={toTarget}
          design={design}
        />
      )}

      {isEmailChannelWithData(channel) && (
        <FollowUpMessageEmail
          channel={channel}
          setChannelData={setChannelData}
          mergeTags={mergeTags}
          onChange={setDesign}
          toTarget={toTarget}
          design={design}
        />
      )}
    </FollowUpBodySection>
  );
};
